<template>
    <div id="login_page">
        <form v-on:submit.prevent="loginUser">
            <h1>Login</h1>

            <label>
                username
                <input type="text" placeholder="User username" v-model="username">
            </label>

            <label>
                Password
                <input type="password" placeholder="User Password" v-model="password">
            </label>

            <button type="submit">Login</button>

            <div v-if="error !== null" class="auth-error">{{ error }}</div>
        </form>

        <img v-if="authState == 'loading'" src="../assets/triple_loading_icon.gif" alt="Triple Loading in Progress GIF" class="loading-gif">
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: 'AppLogin',
        data() {
            return {
                username: '',
                password: ''
            }
        },
        computed: {
            ...mapGetters(['error', 'authState']),
        },
        methods: {
            ...mapActions(['login']),
            loginUser() {
                let user = {
                    username: this.username,
                    password: this.password
                };

                this.login(user)
                    .then(res => {
                        console.log(res);

                        if (res.data.success) {
                            this.$router.push('/dashboard');
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
            }
        }
    }
</script>

<style lang="scss" scoped>
    #login_page{
        background-color: $primary-two;
        min-height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;

        .loading-gif {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 18rem;
        }

        form{
            width: 100%;
            max-width: 47rem;
            background-color: #fff;
            padding: 4rem;

            h1{
                font-size: 4rem;
                font-weight: 700;
                line-height: 1.3;
                color: $primary-three;
                margin-bottom: 2rem;
            }

            label{
                display: block;
                font-size: 2rem;
                font-weight: 600;
                line-height: 1.3;
                color: $primary-three;
                text-align: left;
                margin-bottom: 2rem;

                &:last-of-type{
                    margin-bottom: 0;
                }

                input{
                    display: block;
                    width: 100%;
                    margin-top: .5rem;
                    font-size: 1.8rem;
                    font-weight: 400;
                    line-height: 1.3;
                    color: $primary-three;
                    padding: 0.3rem 1rem 0.1rem 1rem;
                }
            }

            button{
                font-size: 2rem;
                font-weight: 700;
                line-height: 1.3;
                color: #fff;
                background-color: $primary-one;
                border: 0;
                outline: 0;
                margin-top: 2rem;
                padding: .5rem 3rem;
            }

            .auth-error {
                margin-top: 2rem;
                font-size: 1.6rem;
                font-weight: 600;
                line-height: 1.3;
                color: #fdab2f;
            }
        }
    }
</style>